<div id="upload-form" class="col xs12 s12 m12 l12 xl9 top-padding-16">
  <div class="form-layout">
    <form #myForm="ngForm" novalidate [formGroup]="editForm">
      <div class="upload-form">
        <div class="row">
          <div class="col s12 m12 l6 xl4 bold" id="rCount">Record Count<span class="k-required">*</span>:</div>
          <div class="col s12 m12 l6 xl8">
            <kendo-numerictextbox id="recordCount" class="form-control" [format]="'n0'" formControlName="recordCount"
              [value]="0" [min]="0" [max]="maxRecordCount" [autoCorrect]="true" [spinners]="false"
              (valueChange)="onCountChange()">
            </kendo-numerictextbox>
            <div class="top-margin-1 max-content-width">
              <span class="left-margin-0 tooltip-validation inherit-position" id="rc-warning"
                *ngIf="editForm.controls.recordCount.touched && editForm.controls.recordCount.errors && editForm.controls.recordCount.invalid">
                {{config.RecordCountWarning}}
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s12 m12 l6 xl4 bold" id="tAmount">Total Amount<span class="k-required">*</span>:</div>
          <div class="col s12 m12 l6 xl8">
            <kendo-numerictextbox id="totalCount" formControlName="totalAmount" class="form-control" [format]="'c'"
              [value]="0" [min]="0" [max]="maxAmount" [autoCorrect]="true" [spinners]="false" [decimals]="decimals"
              (valueChange)="onAmountChange()">
            </kendo-numerictextbox>
            <div class="top-margin-1 max-content-width">
              <span class="left-margin-0 tooltip-validation inherit-position" id="ta-warning"
                *ngIf="editForm.controls.totalAmount.touched && editForm.controls.totalAmount.errors && editForm.controls.totalAmount.invalid">
                {{config.AmountWarning}}
              </span>
            </div>
          </div>
        </div>
        <div class="row text-area-resize">
          <div class="col s12 m12 l6 xl4 bold" id="notes">Comments (Optional):</div>
          <div class="col s12 m12 l6 xl8">
            <textarea class="k-textarea" kendoTextArea [autoSize]="true" maxlength="240" formControlName="notes"
              aria-label="notes" id="textArea" class="full-width"></textarea>
          </div>
        </div>
        <div class="left-margin-10 bottom-margin-10" id="textMsg">
          {{config.Disclaimer}}
        </div>
        <div class="left-margin-10 file-upload">
          <kendo-upload #myUpload class="kendo-upload" [autoUpload]="false" [saveUrl]="uploadSaveUrl" [multiple]="false"
            [removeUrl]="uploadRemoveUrl" [restrictions]="config.UploadFileRestrictions" [disabled]="disableButton"
            (complete)="uploadComplete(myUpload)" (upload)="uploadEventHandler($event, myForm.value)"
            (success)="uploadSuccess($event)" (select)="selectEventHandler($event)" (error)="errorEventHandler()">
            <kendo-upload-messages select="Select a file..">
            </kendo-upload-messages>
          </kendo-upload>
        </div>
      </div>
    </form>
  </div>
</div>
